import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import delhi from "../../../../assets/indiagate.webp";
import noida from "../../../../assets/noida.webp";
import ghaziabad from "../../../../assets/ghaziabad.webp";
import gurugram from "../../../../assets/gurugram.webp";

import Navbar from "../../../LandingPage/Navbar";
import Porter from "../Porter";
import Areas from "../Areas";
import Transportation from "../Transportation";

import DeliveryCard from "./DeliveryCard/DeliveryCard";
import VehicleFareCard from "./VehicleFareCard/VehicleFareCard";
import TrackingOrderCard from "./TrackingOrderCard/TrackingOrderCard";
import CaptainSearchingCard from "./CaptainSearchingCard/CaptainSearchingCard";
import AddCustomerDetails from "./AddCustomerDetails";
import Footer from "../../../LandingPage/Footer";
import Gateway from "../../../Login/Gateway";
import DownloadApp from "../DownloadApp";

const Bookings = () => {
  const location = useLocation();

  const rawSelectedCity =
    location.state?.city || sessionStorage.getItem("selectedCity") || "Delhi";

  const normalizeCityName = (city = "") => {
    const value = String(city).trim().toLowerCase();

    if (value.includes("delhi")) return "Delhi";
    if (value.includes("noida")) return "Noida";
    if (value.includes("gurugram") || value.includes("gurgaon"))
      return "Gurugram";
    if (value.includes("gaziabad") || value.includes("ghaziabad"))
      return "Ghaziabad";

    return "Delhi";
  };

  const selectedCity = normalizeCityName(rawSelectedCity);

  const initialVehicle = location.state?.vehicle || "Two Wheeler";

  const [selectedVehicle, setSelectedVehicle] = useState(initialVehicle);
  const [acceptedRide, setAcceptedRide] = useState(null);
  const [selectedFare, setSelectedFare] = useState(0);

  const [activeCard, setActiveCard] = useState(null);

  const [deliveryForm, setDeliveryForm] = useState({
    customerId: "",
    userId: "",

    firstName: "",
    lastName: "",
    privacyPolicy: false,

    pickupAddress: "",
    pickupLatitude: "",
    pickupLongitude: "",

    dropAddress: "",
    dropLatitude: "",
    dropLongitude: "",

    senderName: "",
    senderMobile: "",
    receiverName: "",
    receiverMobile: "",

    deliveryType: "instant",
    scheduleDate: "",
    scheduleTime: "",
  });

  const [selectedVehicleMeta, setSelectedVehicleMeta] = useState({
    weight: "",
    dimension: "",
  });

  const cityBanners = {
    Delhi: delhi,
    Noida: noida,
    Ghaziabad: ghaziabad,
    Gaziabad: ghaziabad,
    Gurugram: gurugram,
    Gurgaon: gurugram,
  };

  const banner = cityBanners[selectedCity] || delhi;

  const cleanMobile = (value) => {
    return String(value || "").replace(/\D/g, "");
  };

  const getSessionUser = () => {
    try {
      const storedUser = sessionStorage.getItem("user");

      if (!storedUser) return null;

      return JSON.parse(storedUser);
    } catch (error) {
      console.error("Invalid session user:", error);
      return null;
    }
  };

  const getMobileFromUser = (userData, mobileFromGateway = "") => {
    const storedLoginMobile = sessionStorage.getItem("login_mobile");

    return cleanMobile(
      mobileFromGateway ||
        storedLoginMobile ||
        userData?.mobile ||
        userData?.phone ||
        userData?.customerMobile ||
        userData?.mobileNumber ||
        userData?.username ||
        "",
    );
  };

  const loadSavedCustomerDetails = (mobile) => {
    if (!mobile) return null;

    try {
      const savedCustomerDetails = localStorage.getItem(
        `booking_customer_${mobile}`,
      );

      if (!savedCustomerDetails) return null;

      return JSON.parse(savedCustomerDetails);
    } catch (error) {
      console.error("Invalid saved customer details:", error);
      return null;
    }
  };

  const hasCompletedCustomerProfile = (userData, savedDetails = null) => {
    const firstName =
      userData?.firstName ||
      userData?.first_name ||
      userData?.firstname ||
      savedDetails?.firstName ||
      savedDetails?.first_name ||
      savedDetails?.firstname ||
      "";

    const lastName =
      userData?.lastName ||
      userData?.last_name ||
      userData?.lastname ||
      savedDetails?.lastName ||
      savedDetails?.last_name ||
      savedDetails?.lastname ||
      "";

    const privacyPolicy =
      userData?.privacyPolicy ||
      userData?.privacy_policy ||
      userData?.privacy_policy_accepted ||
      savedDetails?.privacyPolicy ||
      savedDetails?.privacy_policy ||
      savedDetails?.privacy_policy_accepted ||
      "";

    const isPrivacyAccepted =
      privacyPolicy === "Y" ||
      privacyPolicy === true ||
      privacyPolicy === "true";

    return Boolean(firstName?.trim() && lastName?.trim() && isPrivacyAccepted);
  };

  const openBookingWithMobile = (mobile, savedDetails = null) => {
    const fullName = `${savedDetails?.firstName || ""} ${
      savedDetails?.lastName || ""
    }`.trim();

    setDeliveryForm((prev) => ({
      ...prev,
      ...(savedDetails || {}),

      customerId:
        prev.customerId ||
        savedDetails?.customerId ||
        savedDetails?.userId ||
        mobile ||
        "",

      userId: prev.userId || savedDetails?.userId || mobile || "",

      senderName: prev.senderName || savedDetails?.senderName || fullName || "",
      senderMobile: savedDetails?.senderMobile || mobile || prev.senderMobile,
    }));

    setActiveCard("booking");
  };

  const openCustomerWithMobile = (mobile) => {
    setDeliveryForm((prev) => ({
      ...prev,
      customerId: prev.customerId || mobile || "",
      userId: prev.userId || mobile || "",
      senderMobile: mobile || prev.senderMobile,
    }));

    setActiveCard("customer");
  };

  useEffect(() => {
    const sessionUser = getSessionUser();

    if (sessionUser) {
      const mobile = getMobileFromUser(sessionUser);
      const savedDetails = loadSavedCustomerDetails(mobile);

      if (hasCompletedCustomerProfile(sessionUser, savedDetails)) {
        const firstName =
          sessionUser?.firstName || savedDetails?.firstName || "";

        const lastName = sessionUser?.lastName || savedDetails?.lastName || "";

        openBookingWithMobile(mobile, {
          firstName,
          lastName,
          privacyPolicy:
            sessionUser?.privacyPolicy === "Y" ||
            savedDetails?.privacyPolicy === true ||
            savedDetails?.privacyPolicy === "Y",
          senderMobile: mobile,
        });

        return;
      }

      openCustomerWithMobile(mobile);
      return;
    }
    setActiveCard("gateway");
  }, []);

  const handleGatewayNext = (mobileFromGateway, userDataFromGateway = null) => {
    const sessionUser = getSessionUser();
    const finalUserData = userDataFromGateway || sessionUser;

    const mobile = getMobileFromUser(finalUserData, mobileFromGateway);

    if (mobile) {
      sessionStorage.setItem("login_mobile", mobile);
    }

    const savedDetails = loadSavedCustomerDetails(mobile);

    const isOldCustomer = hasCompletedCustomerProfile(
      finalUserData,
      savedDetails,
    );

    if (isOldCustomer) {
      const firstName =
        finalUserData?.firstName || savedDetails?.firstName || "";

      const lastName = finalUserData?.lastName || savedDetails?.lastName || "";

      openBookingWithMobile(mobile, {
        firstName,
        lastName,
        privacyPolicy:
          finalUserData?.privacyPolicy === "Y" ||
          savedDetails?.privacyPolicy === true ||
          savedDetails?.privacyPolicy === "Y",
        senderMobile: mobile,
      });

      return;
    }

    openCustomerWithMobile(mobile);
  };

  const handleCustomerNext = () => {
    const sessionUser = getSessionUser();

    const mobile = cleanMobile(
      deliveryForm?.senderMobile || getMobileFromUser(sessionUser),
    );

    if (mobile) {
      sessionStorage.setItem("login_mobile", mobile);
      sessionStorage.setItem("customerId", mobile);
      sessionStorage.setItem("userId", mobile);

      localStorage.setItem(
        `booking_customer_${mobile}`,
        JSON.stringify({
          customerId: mobile,
          userId: mobile,
          firstName: deliveryForm.firstName || "",
          lastName: deliveryForm.lastName || "",
          privacyPolicy: deliveryForm.privacyPolicy || false,
          senderMobile: mobile,
        }),
      );
    }

    setDeliveryForm((prev) => ({
      ...prev,
      customerId: prev.customerId || mobile || "",
      userId: prev.userId || mobile || "",
    }));

    setActiveCard("booking");
  };

  return (
    <>
      <Navbar />

      <div className="relative flex min-h-[580px] flex-col items-center justify-start overflow-hidden px-3 pb-6 pt-[80px] sm:pt-[85px] md:min-h-[720px] md:pt-[90px] lg:min-h-[760px] lg:pt-[95px] xl:pt-[100px]">
        <div className="image-section absolute left-0 top-0 -z-10 !h-[100%] w-full">
          <img
            src={banner}
            alt="bg"
            className="h-full w-full object-cover object-top"
          />

          <div className="image-overlay absolute inset-0 bg-black/30"></div>
        </div>

        {activeCard === null && (
          <div className="rounded-2xl bg-white px-6 py-4 text-sm font-semibold text-slate-700 shadow-lg">
            Loading...
          </div>
        )}

        {activeCard === "gateway" && (
          <Gateway
            isBookingFlow={true}
            selectedCity={selectedCity}
            onNext={handleGatewayNext}
          />
        )}

        {activeCard === "customer" && (
          <AddCustomerDetails
            formData={deliveryForm}
            setFormData={setDeliveryForm}
            selectedCity={selectedCity}
            onNext={handleCustomerNext}
          />
        )}

        {activeCard === "booking" && (
          <DeliveryCard
            formData={deliveryForm}
            setFormData={setDeliveryForm}
            selectedVehicle={selectedVehicle}
            onNext={() => setActiveCard("fare")}
          />
        )}

        {activeCard === "fare" && (
          <VehicleFareCard
            formData={deliveryForm}
            setFormData={setDeliveryForm}
            selectedVehicle={selectedVehicle}
            setSelectedVehicle={setSelectedVehicle}
            setSelectedFare={setSelectedFare}
            setSelectedVehicleMeta={setSelectedVehicleMeta}
            onBack={() => setActiveCard("booking")}
            onNext={(data) => {
              setDeliveryForm((prev) => ({
                ...prev,
                parcelId: data?.parcelId,
              }));

              setActiveCard("captain");
            }}
          />
        )}

        {activeCard === "captain" && (
          <CaptainSearchingCard
            formData={deliveryForm}
            selectedVehicle={selectedVehicle}
            baseFare={selectedFare}
            vehicleMeta={selectedVehicleMeta}
            onBack={() => setActiveCard("fare")}
            onNext={(rideData) => {
              setAcceptedRide(rideData);
              setActiveCard("tracking");
            }}
          />
        )}

        {activeCard === "tracking" && (
               <TrackingOrderCard
  formData={deliveryForm}
  parcelId={deliveryForm?.parcelId}
  selectedVehicle={selectedVehicle}
  acceptedRide={acceptedRide}
  vehicleMeta={selectedVehicleMeta}
  onBack={() => setActiveCard("captain")}
  onCancel={() => setActiveCard("booking")}
  onNext={() => {}}
/>
        )}
      </div>

      <Porter />
      <Areas />
      <DownloadApp />
      <Transportation />
      <Footer />
    </>
  );
};

export default Bookings;
